module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-signature detenteur fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4",
    class: {
      'is-fullscreen': _vm.fullscreen
    }
  }, [_c('div', {
    staticClass: "modal relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-6"
  }, [_vm._m(0), _vm._v(" "), _c('canvas', {
    ref: "canvasPad",
    staticClass: "signature block w-full border border-gray-200 rounded-lg",
    staticStyle: {
      "touch-action": "none"
    },
    attrs: {
      "id": "signaturepad",
      "width": _vm.canvasWidth,
      "height": _vm.canvasHeight
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "warning text-sm text-alert mt-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-4 gap-3",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('a', {
    staticClass: "btn-alert clean",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearPad($event)
      }
    }
  }, [_vm._v("Effacer")]), _vm._v(" "), _c('a', {
    staticClass: "btn-primary save",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.savePad($event)
      }
    }
  }, [_vm._v("Enregistrer")])]), _vm._v(" "), _c('i', {
    staticClass: "fas",
    class: _vm.fullscreen ? 'fa-compress' : 'fa-expand',
    attrs: {
      "id": "fullscreen-sign"
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-close-circle bg-alert absolute top-4 right-4 cursor-pointer",
    attrs: {
      "id": "close-sign"
    },
    on: {
      "click": _vm.closePad
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "text-center text-xl font-semibold text-gray-800 leading-snug mb-4"
  }, [_c('strong', [_vm._v("Enregistrer")]), _c('br'), _vm._v("\n      une signature\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81b882f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SignatureModal.vue
// module id = 1043
// module chunks = 0